import React, { useEffect, useState, useContext } from 'react'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import axios from 'axios';
import { Container } from '@mui/system';
import Grid from '@mui/material/Grid';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import LoaderDialog from './LoaderDialog'
import { AuthContext } from '../authContext/AuthContext'
import { getQtyNumber } from '../util.js'

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const ItemWiseReport = ({startDate, endDate}) => {
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false)
  const { user, shop } = useContext(AuthContext);
  useEffect(() => {
    const loadData = async() => {
      setLoading(true)
      try {
        const columns = [
          {"field": "id", "headerName": "#", "key":"aa"},
          {"field": "_id", "headerName": "Date"},
          {"field": "itemKey", "headerName": "Item Key"},
          {"field": "itemName", "headerName": "Item Name", width: 350},
          {"field": "quantity", "headerName": "Quantity"}]
        let d = new Date(endDate)
        d.setDate(d.getDate() + 1)
        const newEndDate = d.toISOString().split('T')[0]
        const res = await axios.post("/orders/itemWiseReport", {startDate, endDate: newEndDate}, {headers: {token:"Bearer " + user.token, shopkey: shop.shopkey}})
        const sortedData = res.data.sort((a,b) => {return new Date(a._id.date).getTime() - new Date(b._id.date).getTime()});
        
        let sd = []
        sortedData.map((item, index)=> sd.push({"_id": convertDate(item._id.date), "id": index + 1, "itemKey": item._id.itemKey, "itemName": item._id.itemName, "quantity": getQtyNumber(item.quantity).toFixed(3)}))
        if(sd) {
          setData({"rows": sd, "columns": columns})
        }
        setLoading(false)
      } catch (err) {
        console.log(err)
        setLoading(false)
      }
    }
    loadData();
  },[startDate, endDate, user, shop]);
  const convertDate = (dateStr) => {
    const d = new Date(dateStr);
    return d.getDate() + "/" + (d.getMonth() + 1) + "/" +  d.getFullYear();
  }
  
  return (
    <Container maxWidth="false" disableGutters sx={{height: "85vh", width: "100vw"}}>
      <LoaderDialog open={loading} title="Loading Report Data ..."/>
      <Grid container>
        {data && <DataGrid {...data} components={{ Toolbar: GridToolbar }} sx={{height: "85vh", width: "100vw"}}/>}
      </Grid>
    </Container>
  )
}

export default ItemWiseReport
